export const MULTISEARCH_TEXT_FILTER_REGEX = RegExp(/[^A-Za-z0-9./-]/g);
export const MULTISEARCH_MINIMUM_LENGTH_SEARCHTERM = 3;
